import { render, staticRenderFns } from "./UserStockListOverview.vue?vue&type=template&id=64711827&scoped=true&"
import script from "./UserStockListOverview.vue?vue&type=script&lang=js&"
export * from "./UserStockListOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserStockListOverview.vue?vue&type=style&index=0&id=64711827&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64711827",
  null
  
)

export default component.exports